module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead8-863cfb4982dcad8261d6a47bca3420b2.jpg";